<template>
    <div style="py-5">
        <section class="banner">
            <div class="container dados-equipe">
                <!--
                <div class="img-dr mx-auto">
                </div>
            -->
                <h1 class="font-weight-bold text-center">
                    Rogério Oliveira
                </h1>
                <br><br>
                <p class="text-white h6 mx-auto w-75 text-justify">
                    <ul>
                       <li>Terapeuta Ocupacional - UFSCar- Universidade Federal de São Carlos;</li>
                       <li>Pós-Graduação em Terapia da Mão e Reabilitação Neurológica do Membro Superior - UFSCar; </li>
                       <li>Pós-Graduação em Tecnologia Assistiva (Adequação Postural, Seating, órteses e próteses e adaptações, sistemas de alta tecnologia computacional) - FCMMG - Faculdade de Ciências Médicas de Minas Gerais;</li>
                       <li>Terapeuta Ocupacional responsável pelo ambulatório de TO em DNM|ELA – Setor de Investigações nas Doenças Neuromusculares da UNIFESP;</li>
                       <li>Diretor da ABRAFEU - Associação Brasileira em distrofia fáscioescápuloumeral;</li>
                       <li>Conselheiro da ABRELA - Associação Brasileira de Esclerose Lateral Amiotrófica;</li>
                       <li>Terapeuta Ocupacional voluntário da ABDIM viver bem sem limites;</li>
                       <li>Terapeuta Ocupacional voluntário da Associação PRÓ-CURA DA ELA;</li>
                       <li>Pioneiro no Brasil em sistemas de comunicação Eyetracking para controle ocular de computadores por pacientes com ELA;</li>
                       <li>Professor convidado da pós graduação em Tecnologia Assistiva. Technocare-FCCMG;</li>
                       <li>Técnico em Telecomunicações- SENAI;</li>
                       <li>Palestrante em Tecnologia Assistiva;</li>
                    </ul> 
                </p>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    data(){
        return{
            urlPaginas:
                "https://cms.fastcode.com.br/api/paginas?url=rogerio-oliveira",
            pagina: [],
            title: "",
            seotittle: "",
            desc: "",
            key: ""
        }
    },
    mounted(){
        this.seoGet();
        this.$ga.page("/rogerio-oliveira");
    },
    methods:{
        seoGet() {
            fetch(this.urlPaginas, {
                method: "get",
                headers: { Authorization: this.token }
            })
            .then(response => response.json()) // retorna uma promise
            .then(response => {
            this.pagina = response.data;
            this.title = this.pagina.despagina ? this.pagina.despagina : "";
            this.seotittle = this.pagina.destitle ? this.pagina.destitle : "";
            this.desc = this.pagina.desdescription ? this.pagina.desdescription : "";
            this.key = this.pagina.deskeywords ? this.pagina.deskeywords : "";
            this.$emit("updateHead");
            });
        },
    },
    head: {
        title: function() {
            return { inner: this.seotittle };
        },
        link: function() {
            return [
                { rel: "canonical", href: window.location.href, id: "canonical" }
            ];
        }
    }
}
</script>

<style scoped>
ul {
    font-weight: 600;
    font-size: 20px;
}
section.banner {
    background: linear-gradient(rgba(0, 0, 0, 0.3)), url("../assets/images/WhoWeAre/rogerio.jpg") no-repeat;
    background-size: cover;
    min-height: 100%;
    /* background-position-y: -141px; */
    /* padding-top: 446px; */
    height: auto;
}
section.banner h1,section.banner p{
  position: relative;
}
.img-dr {
    background: url("../assets/images/WhoWeAre/photorogerio.png");
    background-size: cover;
    background-position: center;
    width: 220px;
    height: 250px;
    float: right;
    margin-bottom: 40px;
}
p {
    line-height: 30px;
}
.container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 200px 0;
}
button {
    width: 120px;
}
@media (max-width: 480px){
    section.banner {
        background-position-x: -761px!important;
    }
}
</style>